import React, { FC } from 'react';
import { OtpInputProps } from './desktopPinInput.type';
import './desktopPinInput.css';
import { getIdAttributes } from '../../utils/helper';

export const idPrefix: string = 'desktop-pin-input';

const DesktopPinInput: FC<OtpInputProps> = (props) => {
  const length: number = props.inputLength || 0;

  const handleChange = (index: number, value: string) => {
    if (!/^[0-9]?$/.test(value)) return;

    const otpArray: string[] = props.otp.padEnd(length, ' ').split('');
    otpArray[index] = value;
    const updatedOtp: string = otpArray.join('').trimEnd();
    props.setOtp(updatedOtp);

    if (value && index < length - 1) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      nextInput?.focus();
    }
  };

  const handleKeyDown = (
    index: number,
    e: React.KeyboardEvent<HTMLInputElement>,
  ) => {
    if (e.key === 'Backspace' && !props.otp[index] && index > 0) {
      const prevInput = document.getElementById(`otp-${index - 1}`);
      prevInput?.focus();
    }
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('Text').replace(/\D/g, '');
    if (!pasted) return;
    const otpString = pasted.slice(0, length);
    props.setOtp(otpString);
  };

  return (
    <div className="flex gap-3">
      {Array.from({ length }).map((_, index: number) => (
        <input
          key={index}
          {...getIdAttributes(idPrefix, `otp-input-${index}`)}
          id={`otp-${index}`}
          type="text"
          inputMode="numeric"
          maxLength={1}
          placeholder={props.placeholder}
          disabled={props.isDisable}
          value={props.otp[index] || ''}
          onChange={(e) => handleChange(index, e.target.value)}
          onKeyDown={(e) => handleKeyDown(index, e)}
          className={
            props.inputClassName
              ? props.inputClassName
              : `verifyOtpContainer${
                  props.hasError
                    ? ' border border-[#D80000] text-[#D80000]'
                    : ''
                }`
          }
          onPaste={handlePaste}
        />
      ))}
    </div>
  );
};

export default DesktopPinInput;
